import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { getCompanySnippetsQuery } from '../../../../../services';

export const useCompanySnippets = () => {
  const [search, setSearch] = useState<string>('');

  // TODO: Extend api call with pagination, sorting, and search options
  const { data: snippets, isLoading } = useQuery(getCompanySnippetsQuery());

  return {
    search,
    setSearch,
    isLoading,
    snippets:
      snippets?.filter(snippet =>
        snippet.Name.toLowerCase().includes(search.toLowerCase())
      ) || []
  };
};
